/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { api } from '../axios';
import { Messages, StudyResponse } from '../../types';
import Authentication from './Authentication';
import Mongo from './Mongo';
import NotifyHelper from '../NotifyHelper';

const SCHEDULE_ENDPOINT = '/schedules';

class StudyControl extends Mongo {
  public async fetchCurrentStudy(): Promise<StudyResponse | undefined> {
    try {
      const loginData = Authentication.loggedUser();
      if (!loginData) return;
      const where = {
        user_email: loginData.user.email,
        contest_id: loginData.contest._id,
      };
      const flattenQuery = this.flattenMongoQuery({ query: where }) as unknown;
      const response: StudyResponse = await api.get(SCHEDULE_ENDPOINT, {
        params: {
          where: flattenQuery,
          sort: this.parseSortArr([['_created', 'desc']]),
        },
      });
      return response;
    } catch (error) {
      console.error(error);
      NotifyHelper.notifyError(Messages.FETCH_STUDIES_ERROR);
    }
  }
  public async createStudy(): Promise<void> {
    try {
      const loginData = Authentication.loggedUser();
      if (!loginData) return;
      await api.post(SCHEDULE_ENDPOINT, {
        user_email: loginData.user.email,
        contest_id: loginData.contest._id,
      });
    } catch (error) {
      console.error(error);
      NotifyHelper.notifyError(Messages.SAVE_STUDY_ERROR);
    }
  }
  public async pauseStudy({
    paused,
    etag,
    id,
  }: {
    paused: boolean;
    etag: string;
    id: string;
  }): Promise<void> {
    try {
      await api.patch(
        `${SCHEDULE_ENDPOINT}/${id}`,
        { paused },
        { headers: { 'If-Match': etag } }
      );
    } catch (error) {
      console.error(error);
      NotifyHelper.notifyError(Messages.PAUSE_STUDY_ERROR);
    }
  }
}

export default new StudyControl();
